const { MinimogThemeStyles, MinimogThemeScripts } = window
class QuickView {
  constructor() {
    ;(this.modal = new MinimogTheme.Modal()),
      (this.isOpen = !1),
      addEventDelegate({
        selector: '.m-product-quickview-button',
        handler: (e, i) => {
          e.preventDefault(), (this.target = i), this.toggleLoading(this.target, !0)
          const t = i.dataset.productHandle
          t && this.fetchHtml(t)
        },
      }),
      window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
        this.modal && MinimogTheme.ProductQuickView.close()
      })
  }
  fetchHtml(e) {
    loadAssetsNew([MinimogThemeStyles.product], 'quick-view-assets'),
      fetchSection('product-quickview', {
        url: `${window.MinimogSettings.base_url}products/${e}`,
      })
        .then((e) => {
          this.modalContent = e.querySelector('.m-product-quickview')
          const i = e.querySelector('product-model')
          ;(this.mediaGallery = this.modalContent.querySelector('media-gallery')),
            loadAssetsNew(
              [MinimogThemeScripts.productMedia, MinimogThemeScripts.variantsPicker],
              'variants-picker',
              () => {
                this.modal.appendChild(this.modalContent),
                  this.modal.setWidth('960px'),
                  this.modal.open(),
                  this.toggleLoading(this.target, !1),
                  (this.isOpen = !0)
              }
            ),
            i &&
              loadAssetsNew(
                [
                  MinimogThemeScripts.productModel,
                  'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css',
                ],
                'product-model-assets'
              )
        })
        .catch(console.error)
  }
  close(e) {
    this.modal.close(e), (this.isOpen = !1)
  }
  toggleLoading(e, i) {
    i ? e.classList.add('m-spinner-loading') : e.classList.remove('m-spinner-loading')
  }
}
MinimogTheme.ProductQuickView = new QuickView()
